module.exports = __webpack_public_path__ + "static/media/gallery-2.abbb721d.jpg";